import request from '@/plugins/request'

export function grabGpInfoByIds(keyIds) {
    return request({
        url: '/v1/Task/GrabGpInfoByIds',
        method: 'post',
        data: {
            keywordIds: keyIds,
        }
    })
}

export function grabSbInfoByIds(keyIds) {
    return request({
        url: '/v1/Task/GrabSbInfoByIds',
        method: 'post',
        data: {
            keywordIds: keyIds,
        }
    })
}

export function delAllTask() {
    return request({
        url: '/v1/Task/DelAllTask',
        method: 'post',
    })
}


export function grabInfoBySearch(key, parids, pageindex, pagesize) {
    return request({
        url: '/v1/Task/GrabInfoBySearch',
        method: 'post',
        data: {
            key: key,
            parIds: parids,
            pageIndex: pageindex,
            pageSize: pagesize
        }
    })
}

export function grabEtfInfo(etfIds) {
    return request({
        url: '/v1/Task/GrabEtfInfo',
        method: 'post',
        data: {
            etfIds: etfIds,
        }
    })
}

export function delAllEtfTask() {
    return request({
        url: '/v1/Task/DelAllEtfTask',
        method: 'post',
    })
}